import Vue from 'vue'
import Febs from './FEBS'
import router from './router'
import Antd from 'ant-design-vue'
import store from './store'
import request from 'utils/request'
import db from 'utils/localstorage'
import VueApexCharts from 'vue-apexcharts'
// import requestGov from 'utils/request'
// import requestCom from 'utils/request-com'
// import requestSys from 'utils/request-system'
import util from 'utils/index'
// import $ from 'jquery'
// import VueParticles from 'vue-particles'
// import echarts from 'echarts'
import * as echarts from 'echarts'
import 'ant-design-vue/dist/antd.css'
import { deepClone } from '@/utils/permissionDirect'
import 'utils/install'

// import './mock/index.js'
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(db)
Vue.use(VueApexCharts)
// ie11报错 package.json注释掉 // "vue-particles": "^1.0.9",
// Vue.use(VueParticles)

Vue.component('apexchart', VueApexCharts)

Vue.use({
  install (Vue) {
    Vue.prototype.$db = db
  }
})

Vue.prototype.$post = request.post
Vue.prototype.$post_json = request.post_json
Vue.prototype.$get = request.get
Vue.prototype.$put = request.put
Vue.prototype.$delete = request.delete
Vue.prototype.$export = request.export
Vue.prototype.$exportZip = request.exportZip
Vue.prototype.$download = request.download
Vue.prototype.$upload = request.upload
Vue.prototype.$echarts = echarts
Vue.prototype.deepClone = deepClone
// Vue.prototype.$post_gov = request.post
// Vue.prototype.$get_gov = request.get
// Vue.prototype.$put_gov = request.put
// Vue.prototype.$delete_gov = request.delete
// Vue.prototype.$export_gov = request.export
// Vue.prototype.$download_gov = request.download
// Vue.prototype.$upload_gov = request.upload
// // 系统管理
// Vue.prototype.$post_sys = requestSys.post
// Vue.prototype.$post_jsons_sys = requestSys.post_json
// Vue.prototype.$get_sys = requestSys.get
// Vue.prototype.$put_sys = requestSys.put
// Vue.prototype.$delete_sys = requestSys.delete
// Vue.prototype.$export_sys = requestSys.export
// Vue.prototype.$exportZip_sys = requestSys.exportZip
// Vue.prototype.$download_sys = requestSys.download
// // 保险公司端
// Vue.prototype.$post_com = requestCom.post
// Vue.prototype.$post_jsons_com = requestCom.post_json
// Vue.prototype.$get_com = requestCom.get
// Vue.prototype.$put_com = requestCom.put
// Vue.prototype.$delete_com = requestCom.delete
// Vue.prototype.$export_com = requestCom.export
// Vue.prototype.$exportXls_com = requestCom.exportXls
// Vue.prototype.$download_com = requestCom.download
// Vue.prototype.$upload_com = requestCom.upload
// Vue.prototype.$upload = request.upload
// Vue.prototype.$echarts = echarts
// Vue.prototype.deepClone = deepClone

Vue.prototype.util = util
// 自定义可关闭warn message
const myMessageWarn = (dom, content, duration, onClose) => {
  let _remove
  // 创建 VNode

  const h = dom.$createElement
  // let innerText = h('span', { style: { color: '#000000A6' } }, content);
  // content="测试111111111111111111111111111111111<br/>测试1<br/>测试2"
  let contents = content.split('<br/>')
  let arr = []
  contents.forEach(ele => {
    let innerText = h('div', { style: { color: '#000000A6', paddingRight: '13px', paddingLeft: '13px' } }, ele)
    arr.push(innerText)
  })
  let innerIcon = h('a-icon', {
    style: { marginRight: '0px', marginLeft: '20px', color: '#ccc', cursor: 'pointer', position: 'absolute', right: '-8px' },
    attrs: { type: 'close' },
    on: { click: () => _remove() }
  })
  let warningIcon = h('a-icon', {
    style: { position: 'absolute', left: '-8px' },
    attrs: { type: 'warning' }
  })
  arr.push(innerIcon)
  arr.push(warningIcon)
  let box = h('div', { style: { position: 'relative', textAlign: 'left' } }, arr)
  // [innerText, innerIcon]
  // console.log(arr)

  let container = h('span', {}, [box])
  let defaultIcon = h('span', {}, [])
  // 调用 Message 组件
  _remove = dom.$message.warning({
    content: container,
    duration: duration || 0,
    onClose: onClose,
    icon: defaultIcon
  })
}
Vue.prototype.$myMessageWarn = myMessageWarn
/* eslint-disable no-new */
new Vue({
  router,
  store,
  // render: h => h(Febs)
  render: function (createElement) {
    if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) {
      window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
    return createElement(Febs)
  }
}).$mount('#febs')



// WEBPACK FOOTER //
// ./src/main.js